import { useMutation, UseQueryOptions } from '@tanstack/react-query';
import client from 'api/client';
import { errorMessage } from 'helpers/utils';
import { Edges, Nodes } from './use-get-data';
import { useIsPublicPage } from 'hooks/use-is-public-page';
import { GET_SEARCH_DATA_SELECTED, GET_SEARCH_PUBLIC_DATA_SELECTED } from './constant';

type ProjectResponse = {
  nodes: Nodes;
  edges: Edges;
  relationsCounts: { [key: string]: number };
};

type GetProjectParam = {
  id?: string;
  projectId: string;
};

type QueryKey = Omit<GetProjectParam, 'url'> | string;

export type GetNeo4jData = {
  data: ProjectResponse;
};

type QueryResponse = {
  data: GetNeo4jData;
};

type Options = UseQueryOptions<QueryResponse, Error, GetNeo4jData, QueryKey[]>;

export const useGetSelectedSearchData = (id: string, options: Options) => {
  const isPublicPage = useIsPublicPage();

  const urlSelectedSearch = isPublicPage ? GET_SEARCH_PUBLIC_DATA_SELECTED : GET_SEARCH_DATA_SELECTED;

  const url = urlSelectedSearch.replace(':project_id', id);

  return useMutation({
    mutationFn: (params: { id: string; action: string; _ts?: number }) => client.get(url, { params }),
    onSuccess: (data) => options?.onSuccess?.(data),
    onError: errorMessage,
  });
};
